import RequestAbstract from "../abstract";

export default class TransactionHistories extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-transaction-histories";
    }

}
